module.exports = new __parcel__URL__("PRD Hover.599187af.svg").toString();